import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Speakers = () => {
  return (
    <React.Fragment>
      <SEO title="Speakers | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Plenary Speakers &amp; Invited Speakers
        "
        content="For Participants"
        contentTwo="Plenary Speakers &amp; Invited Speakers
        "
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <span>&nbsp;</span>
          <span>&nbsp;</span>
          <p align="justify">
            <h3 id="p1">Plenary Speech I:</h3>
            <h4>Of Mice and Robots: Robot Swarms as Avatars of Tumors</h4>
            <br />
            <h5>Abstract:</h5>
            Biological organs are amazingly complex, and it is said that the
            human brain is the most complex structure in the universe. In the
            case of dysfunctional organs, such as cancer tumors, that
            complexity leads to enormous difficulties in modeling and
            understanding the dynamics of the system. With my colleagues, we
            have explored creating analog/digital robot swarms that mimic
            fundamental aspects of cell-cell interactions. I will present basic
            results and opportunities for the future in this &quot;moon-shot&quot;
            project.
            <br />
            <br />
            <h4>Speaker:</h4>
            <br />
            <p text-align="center">
              <img
                src="images/speaker/AUSTIN_Robert_2024_05_16_china.jpg"
                alt="Robert H. Austin"
                width={200}
              />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Prof. Robert H. Austin</div>
                <br />
                Professor of Physics, Princeton University, USA.
              </strong>
            </p>
            <h5>Biography:</h5>
            Robert H. Austin is Professor of Physics at Princeton University.
            He received his B.A. in Physics from Hope College in Holland, MI,
            and his Ph.D. in Physics from the University of Illinois
            Champaign-Urbana in 1976. He was a post-doc at the Max Planck
            Institute for Biophysical Chemistry from 1976 to 1979 and has been
            at Princeton University since 1979, achieving the rank of Professor
            of Physics in 1989.
            <br />
            <br />
            He is a Fellow of the American Physical Society, a Fellow of the
            American Association for the Advancement of Science, and was elected
            a member of the National Academy of Sciences USA. He has served as
            President of the Division of Biological Physics of the American
            Physical Society and as biological physics editor for Physical
            Review Letters. He won the 2005 Edgar Lilienfeld Prize of the
            American Physical Society.
            <br />
            <br />
            Profile:{" "}
            <a href="https://phy.princeton.edu/people/robert-austin">
              https://phy.princeton.edu/people/robert-austin
            </a>
          </p>
          <hr />

          <span>&nbsp;</span>
          <span>&nbsp;</span>
          <p align="justify">
            <h3 id="p2">Plenary Speech II:</h3>
            <h4>
              The Security Paradox of AI: Vulnerabilities and Resilience in
              Intelligent Systems
            </h4>
            <br />
            <h5>Abstract:</h5>
            Artificial Intelligence (AI) is rapidly becoming the foundational
            layer of hyper-connected digital ecosystems, spanning cyber-physical
            infrastructures, communication networks, autonomous platforms, and
            large-scale distributed services. While AI promises unprecedented
            efficiency, adaptability, and intelligence, it simultaneously
            introduces novel and systemic vulnerabilities. Adversarial
            manipulation, data poisoning, prompt and model exploitation in large
            language models, and emerging threats against agentic and autonomous
            systems expose critical weaknesses in today&apos;s AI deployments.
            Beyond technical exploits, unresolved challenges in transparency,
            explainability, robustness, and ethics further complicate trust in
            AI-enabled decision-making at scale. Yet, AI is not merely a source
            of risk; it is also a powerful instrument for security and
            resilience. Advances in machine learning are enabling intelligent
            intrusion detection, adaptive threat mitigation, anomaly detection
            in dynamic environments, and proactive defense strategies capable of
            responding to evolving attack surfaces. Recent research demonstrates
            how AI-driven mechanisms can enhance situational awareness, automate
            security enforcement, and strengthen system reliability in complex
            and resource-constrained settings. This keynote explores the tension
            between vulnerability and capability in AI-powered systems and
            outlines a forward-looking research agenda toward robust,
            explainable, and trustworthy intelligent infrastructures capable of
            operating securely in an increasingly autonomous and interconnected
            world.
            <br />
            <br />
            <h4>Speaker:</h4>
            <br />
            <p text-align="center">
              <img
                src="images/speaker/图片1.png"
                alt="Muhammad Khurram Khan"
                width={200}
              />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Prof. Muhammad Khurram Khan</div>
                <br />
                Professor of Cybersecurity, King Saud University, Saudi Arabia.
              </strong>
            </p>
            <h5>Biography:</h5>
            Prof. Muhammad Khurram Khan is a global thought leader and
            influencer in cybersecurity. He is a Professor of Cybersecurity at
            the Center of Excellence in Information Assurance (CoEIA), King Saud
            University, Saudi Arabia, and one of the founding members of CoEIA.
            He served as Manager R&amp;D (March 2009 - March 2012), and together
            with his team developed and successfully managed the cybersecurity
            research program at CoEIA.
            <br />
            <br />
            He is the founder and CEO of the Global Foundation for Cyber
            Studies and Research, an independent and non-partisan cybersecurity
            think tank in Washington, D.C., USA. He has contributed to cyber
            policy work for the G20 (Saudi and Italian Presidencies), including
            child online safety, protection of vulnerable populations in
            cyberspace, and enabling women in cybersecurity. He also advises
            startups and companies on strategic R&amp;D, business, and market
            growth.
            <br />
            <br />
            He is the Editor-in-Chief of Springer-Nature&apos;s Telecommunication
            Systems and Area Editor (Cybersecurity) of IEEE Communications
            Surveys &amp; Tutorials, and has served on editorial boards of many
            leading journals. He has organized more than five dozen
            international conferences and served on technical committees of more
            than ten dozen international conferences.
            <br />
            <br />
            Prof. Khurram has received multiple international recognitions,
            including the Lifetime Achievement Award in Cybersecurity (2025),
            Education and Talent Development Award in Cybersecurity (2025), and
            Cybersecurity Excellence Award (2024). He has published over 500
            research papers, is the inventor of 12 US patents, and has secured
            competitive research grants totaling over USD 5 million in
            cybersecurity.
            <br />
            <br />
            His research spans IoT security, vehicular cybersecurity, AI
            security and safety, digital authentication, multimedia security,
            cyber policy, and technological innovation management. He is a
            Fellow of IET (UK), BCS (UK), and FTRA (Korea), and a Senior Member
            of IEEE and IACSIT (Singapore). He currently chairs the
            International Telecommunication Union (ITU) Task Group on Child
            Online Protection in the Metaverse.
            <br />
            <br />
            Detailed profile:{" "}
            <a href="http://www.professorkhurram.com">
              http://www.professorkhurram.com
            </a>
            <br />
            Google Scholar:{" "}
            <a href="https://scholar.google.com/citations?hl=en&user=99LlvYUAAAAJ">
              https://scholar.google.com/citations?hl=en&amp;user=99LlvYUAAAAJ
            </a>
          </p>
          <hr />

          <span>&nbsp;</span>
          <span>&nbsp;</span>
          <p align="justify">
            <h3 id="p3">Plenary Speech III:</h3>
            <h4>
              Evolution of Swarm Intelligence Algorithm &amp; its Impact on
              Modern Systems
            </h4>
            <br />
            <h5>Abstract:</h5>
            One of the most challenging areas of knowledge over the years has
            been the many optimization methodologies. Optimization algorithm
            development and evolution has been the subject of much examination
            and research since the early nineteenth century. In order to tackle
            optimization issues in the fields of science, engineering,
            economics, etc., a variety of gradient-based optimization
            techniques and linear programming approaches have been widely
            employed. In issues with more than one local optimum, these
            techniques haven&apos;t stabilized and haven&apos;t performed well.
            Additionally, neither of them is able to decrease the complexity of
            real-world engineering challenges. Therefore, comprehensive research
            has been done on Swarm Intelligence and numerous algorithms like
            Genetic Algorithm (GA), Particle Swarm Optimization (PSO),
            Differential Evolution (DE), Ant Colony Optimization (ALO), Harmony
            Search (HS), Cuckoo Search (SOS) have been proposed.
            <br />
            <br />
            Now, stability analysis of robust Swarm Intelligence algorithms and
            their application for Smart Manufacturing in Industry 4.0 have been
            emerged as important area of research. Its ensemble analysis along
            with Bounded Input Bounded Output (BIBO) have drawn a significant
            attention due to its astonishing precise and accurate data handling
            performances which is the most essential factor for modern
            communication systems.
            <br />
            <br />
            <h4>Speaker:</h4>
            <br />
            <p text-align="center">
              <img src="images/speaker/图片2.png" alt="Subhabrata Banerjee" width={200} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr. Subhabrata Banerjee</div>
                <br />
                Professor, Institute of Engineering and Management, Kolkata,
                India.
              </strong>
            </p>
            <h5>Biography:</h5>
            Dr. Subhabrata Banerjee is a Professor &amp; Innovation
            Entrepreneurship Development Centre Coordinator in the department of
            Electronics and Communication Engineering, Institute of Engineering
            and Management, School of University of Engineering &amp;
            Management, Kolkata, India. He was awarded National Scholarship by
            WBED, West Bengal Government. He received his M.Tech. and PhD
            degrees in Electronics and Telecommunication Engineering from
            renowned Jadavpur University, Kolkata, India. He initially worked
            as Programmer Analysist in Cognizant Technology Solution and then
            was working as Assistant Professor in the Department of Electronics
            and Communication Engineering at Future Institute of Engineering and
            Management, Kolkata, India and as Associate Professor in the same
            institution thereafter. He is now working as Professor in Institute
            of Engineering and Management, Kolkata, India since 2021. He was
            authored numerous articles published in prestigious journals
            including Wireless Personal Communication (Springer), Personal and
            Ubiquitous Computing (Springer), International Journal of
            Communication Systems (Wiley) and Institution of Engineering and
            Technology (IET, UK). He has published more than 60 papers in
            International Conferences and International Journals of repute. He
            also published book chapter under IET, UK publication. He is also
            the author of three books named Genetic Algorithms &amp; Machine
            Learning for Python Programmers, Hands on Data Visualization Using
            Python &amp; C++ Chronicles Epic Adventures In The Galaxy Of
            Coding. His current research interests include Communication and
            Coding Theory, Machine Learning, Robotics, IOT, Control System, and
            Evolutionary Algorithms, Soft Computation.
          </p>
          <hr />
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Speakers;
